import React, { lazy } from 'react';
import { Assignment, AssignmentStateEnum } from 'types/assignment';
import style from '../style.module.scss';
import { InlineMessage } from '@fattureincloud/fic-design-system';
import { faCalendarTimes, faTimes } from '@fortawesome/pro-regular-svg-icons';

const LazyAssignmentToAccept = lazy(() => import('./components/assignmentToAccept'));
const LazyAssignmentAccepted = lazy(() => import('./components/assignmentAccepted'));
const LazyAssignmentDone = lazy(() => import('./components/assignmentAccepted/assignmentDone'));

type GetDynamicContent = (assignment: Assignment) => JSX.Element;
const getDynamicContent: GetDynamicContent = (assignment) => {
  const { stato, motivazioneChiusura, dataEsecuzione } = assignment;
  switch (stato) {
    case AssignmentStateEnum.TO_ACCEPT:
      return <LazyAssignmentToAccept />;
    case AssignmentStateEnum.ACCEPTED:
      return <LazyAssignmentAccepted />;
    case AssignmentStateEnum.REFUSED:
      return (
        <div className="mb-3">
          <InlineMessage type="error" icon={{ icon: faCalendarTimes }} title="Incarico rifiutato" />
        </div>
      );
    case AssignmentStateEnum.CANCELED:
      return (
        <div className="mb-3">
          <InlineMessage
            type="error"
            icon={{ icon: faTimes }}
            title="Incarico annullato"
            content="L'incarico è stato annullato dall'aministratore di condominio."
          />
        </div>
      );
    case AssignmentStateEnum.DONE_SUCCESS:
    case AssignmentStateEnum.DONE_FAILURE:
      return (
        <LazyAssignmentDone stato={stato} motivazioneChiusura={motivazioneChiusura} dataEsecuzione={dataEsecuzione} />
      );
  }
};

type Props = { assignment: Assignment };

export const DynamicAssignmentContent: React.FC<Props> = ({ assignment }) => (
  <div className={style[`assignment-container`]}>{getDynamicContent(assignment)}</div>
);
